// import Swiper JS
// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination, EffectFade, Autoplay, Lazy } from 'swiper'
Swiper.use([Navigation, Pagination, EffectFade, Autoplay, Lazy])

document.addEventListener('DOMContentLoaded', () => {
  const stages = document.querySelectorAll('.a-stage')

  stages.forEach((stage, index) => {
    const pagination = stage.querySelector('.swiper-pagination')
    const slider = stage.querySelector('.swiper-container')

    // If the index is large than 0 the module is placed somewhere on the page but the start. So it needs the standard fade animation
    if (index > 0) {
      stage.classList.add('wow')
      stage.classList.add('animate__fadeInUp')
    }

    // Create Sliders from every Stage
    const stageSlider = new Swiper(slider, {
      lazy: true,
      speed: 800,
      effect: 'fade',
      autoplay: {
        delay: 6000
      },
      pagination: {
        el: pagination,
        clickable: true
      },
      fadeEffect: {
        crossFade: true
      },
      allowTouchMove: false,
      watchOverflow: true
    })
    stageSlider.init()
    if (stageSlider.slides && stageSlider.slides.length > 3) {
      stageSlider.loop = true
    }
  })
})
